module.exports = __webpack_public_path__ + "assets/img/box-6.8c1a9513.gif";